<!-- MediaList.vue -->
<template>
    <div class="media-list">
        <div
            v-if="!files || files.length === 0"
            class=" media-item d-flex align-items-center p-2 rounded border mb-2 shadow-sm alert alert-light"
            role="status"
            aria-live="polite"
        >
            {{ $t ? $t('general.no_files_found') : 'No files available' }}
        </div>
        <div
            v-else

            v-for="(file, index) in files"
            :key="file.uuid || file.id || file.original_url || index"
            class="media-item d-flex align-items-center p-2 rounded border mb-2 shadow-sm"
        >
            <!-- Thumbnail / Icon -->
            <div class="thumb-wrapper mr-3">
                <template v-if="file.preview_url">
                    <img
                        :src="file.preview_url || file.original_url"
                        alt=""
                        style="cursor: pointer;"
                        class="thumb img-thumbnail"
                        loading="lazy"
                        @click="$emit('image-click', file.original_url)"

                    />
                </template>
                <template v-else>
                    <div class="thumb thumb-icon d-flex flex-column justify-content-center align-items-center">
                        <div class="file-icon">📄</div>
                        <small class="badge badge-secondary mt-1">{{ ext(file) }}</small>
                    </div>
                </template>
            </div>

            <!-- Meta -->
            <div class="flex-fill overflow-hidden">
                <div class="font-weight-bold text-truncate" :title="file.name || file.file_name">
                    {{ file.name || file.file_name || 'Unnamed file' }}
                </div>
                <div class="text-muted small">
                    <span v-if="file.mime_type">{{ file.mime_type }}</span>
                    <span v-if="file.size"> · {{ humanSize(file.size) }}</span>
                </div>
            </div>

            <!-- Actions -->
            <div class="ml-3 d-flex">
                <a
                    :href="file.original_url"
                    target="_blank"
                    rel="noopener"
                    class="btn btn-sm btn-outline-primary mr-2"
                >
                    {{ $t ? $t('general.view') : 'View' }}
                </a>
                <a
                    :href="file.original_url"
                    :download="downloadName(file)"
                    class="btn btn-sm btn-primary"
                >
                    {{ $t ? $t('general.download') : 'Download' }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MediaList',
    props: {
        files: { type: Array, default: () => [] }
    },
    methods: {
        isImage(mime) {
            return typeof mime === 'string' && mime.startsWith('image/');
        },
        ext(file) {
            const name = file.file_name || file.name || '';
            const m = name.match(/\.([a-z0-9]+)$/i);
            return (m && m[1]) ? m[1].toUpperCase() : (file.mime_type ? file.mime_type.split('/')[1]?.toUpperCase() : 'FILE');
        },
        humanSize(bytes) {
            if (!bytes || isNaN(bytes)) return '';
            const units = ['B', 'KB', 'MB', 'GB', 'TB'];
            let i = 0;
            let n = Number(bytes);

            // Hochskalieren bis zur passenden Einheit
            while (n >= 1024 && i < units.length - 1) {
                n /= 1024;
                i++;
            }

            // Mindestens KB erzwingen
            if (i === 0) {
                n = n / 1024; // Bytes -> KB
                i = 1;
            }

            // Nachkommastellen: KB immer 2, darüber wie bisher
            const decimals = i === 1 ? 2 : (n >= 10 || i === 0 ? 0 : 1);
            return `${n.toFixed(decimals)} ${units[i]}`;
        },

        downloadName(file) {
            return file.file_name || file.name || 'download';
        }
    }
};
</script>

<style scoped>
.media-item { background: #fff; }
.thumb-wrapper { width: 64px; height: 64px; }
.thumb { width: 64px; height: 64px; object-fit: cover; }
.thumb-icon { width: 64px; height: 64px; background: #f5f7fa; border: 1px solid #e9ecef; border-radius: .25rem; }
.file-icon { font-size: 22px; line-height: 1; }
@media (prefers-color-scheme: dark) {
    .media-item { background: #1e1f22; border-color: #2b2d31; }
    .thumb-icon { background: #2b2d31; border-color: #3a3d42; }
}
</style>
